import React, { useContext, useEffect, useState } from "react";
import Card from "canvas-core-react/lib/Card";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Margin from "canvas-core-react/lib/Margin";
import IconSavingsIllustrative from "canvas-core-react/lib/IconSavingsIllustrative";
import IconTransferIllustrative from "canvas-core-react/lib/IconTransferIllustrative";
import TextBody from "canvas-core-react/lib/TextBody";
import { HorizontalChart } from "../../chart/horizontal";
import { formatThousandsSeparator, getValues } from "../../../utils/utils";
import "./style.scss";
import { CoachContext } from "../../../context";

export const SavingComponent = () => {
  const [savings, setSavings] = useState(0);
  const [formalDebts, setFormalDebts] = useState(0);
  const [informalDebts, setInformalDebts] = useState(0);

  const { values } = useContext(CoachContext);

  useEffect(() => {
    setSavings(getValues(values, "ahorro", ""));
    setFormalDebts(getValues(values, "deudas", "formal"));
    setInformalDebts(getValues(values != undefined ? values : [], "deudas", "informal"));
  }, []);

  return (
    <>
      <Card>
        <Row>
          <Column xs={4} sm={8} md={12} lg={12}>
            <TextSubtitle component="span">AHORROS Y DEUDAS</TextSubtitle>
          </Column>
        </Row>
        <Margin xs={48} sm={48} md={48} lg={48} side="top">
          <Row justifyContent="center">
            <Column xs={4} sm={8} md={1} lg={1}>
              <IconSavingsIllustrative />
            </Column>
            <Column xs={4} sm={8} md={4} lg={4}>
              <TextSubtitle component="span">
                ${formatThousandsSeparator(savings)}
              </TextSubtitle>
            </Column>
            <Column xs={4} sm={8} md={1} lg={1}>
              <IconTransferIllustrative />
            </Column>
            <Column xs={4} sm={8} md={4} lg={4}>
              <TextSubtitle component="span">
                $
                {formatThousandsSeparator(
                  parseInt(informalDebts.toString()) +
                  parseInt(formalDebts.toString())
                )}
              </TextSubtitle>
            </Column>
          </Row>
        </Margin>
        <Margin>
          <Row justifyContent="center">
            <Column mdOffset={1} lgOffset={1} xs={4} sm={8} md={4} lg={4}>
              <TextBody component="span">Ahorro</TextBody>
            </Column>
            <Column mdOffset={1} lgOffset={1} xs={4} sm={8} md={4} lg={4}>
              <TextBody component="span">Total deudas</TextBody>
            </Column>
          </Row>
        </Margin>
        <Margin>
          <Row justifyContent="center">
            <Column className="test" xs={4} sm={8} md={10} lg={10}>
              <HorizontalChart
                savings={parseInt(savings.toString())}
                informalDebts={parseInt(informalDebts.toString())}
                formalDebts={parseInt(formalDebts.toString())}
              />
            </Column>
          </Row>
        </Margin>
        <Margin>
          <Row justifyContent="center">
            <Column xs={1} sm={1} md={1} lg={1}>
              <div className="box pink" />
            </Column>
            <Column xs={3} sm={7} md={3} lg={2}>
              <TextBody component="span">Ahorros</TextBody>
            </Column>
            <Column xs={1} sm={1} md={1} lg={1}>
              <div className="box purple-white" />
            </Column>
            <Column xs={3} sm={7} md={3} lg={2}>
              <TextBody component="span">Deudas Informales</TextBody>
            </Column>
            <Column xs={1} sm={1} md={1} lg={1}>
              <div className="box purple" />
            </Column>
            <Column xs={3} sm={7} md={3} lg={2}>
              <TextBody component="span">Deudas Formales</TextBody>
            </Column>
          </Row>
          <Row justifyContent="center">
            <Column
              xsOffset={1}
              smOffset={1}
              mdOffset={1}
              lgOffset={1}
              xs={3}
              sm={7}
              md={3}
              lg={2}
            >
              <TextBody component="span">{formatThousandsSeparator(savings)}</TextBody>
            </Column>
            <Column
              xsOffset={1}
              smOffset={1}
              mdOffset={1}
              lgOffset={1}
              xs={3}
              sm={7}
              md={3}
              lg={2}
            >
              <TextBody component="span">{formatThousandsSeparator(informalDebts)}</TextBody>
            </Column>
            <Column
              xsOffset={1}
              smOffset={1}
              mdOffset={1}
              lgOffset={1}
              xs={3}
              sm={7}
              md={3}
              lg={2}
            >
              <TextBody component="span">{formatThousandsSeparator(formalDebts)}</TextBody>
            </Column>
          </Row>
        </Margin>
      </Card>
    </>
  );
};
